// eslint-disable-next-line @typescript-eslint/naming-convention
export enum SOCIAL_PROVIDER {
  facebook = 'facebook',
  twitter = 'twitter',
  google = 'google',
  // UNUSED
  linkedin = 'linkedin',
  github = 'github',
}
